// extracted by mini-css-extract-plugin
module.exports = {"animationWrapper":"solarpanel_100w_flexible_animationWrapper__v62B1"};